/* eslint-disable */
// @ts-ignore
// @ts-nocheck
// @ts-nocheck

import ESLeftSidebar from "./leftSidebar/esLeftSidebar";
import ESPageHeader from "./pageHeader/esPageHeader";

export default function ESLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col flex-auto flex-shrink-0 antialiased bg-white dark:bg-gray-700 text-black dark:text-white">
      <ESLeftSidebar />
      <div className="content-wrapper inner-wrap ml-14 pt-5 pb-10 md:ml-64 ">
        <div className="flex flex-col">
          <ESPageHeader />
          {children}
        </div>
      </div>
    </div>
  );
}
